import { DATED, DAY, DAYS, TEMPLATE } from "../consts/strings";

import memoize from "lodash.memoize";
import moment from "moment-timezone";

export const formatDatedPlanName = (plan) => {
  if (!plan) return;
  const date = moment(plan.activeDate);
  return date.isValid()
    ? `${date.format("DD/MM/YYYY")} (${plan.templateName})`
    : plan.templateName;
};

export const formatTemplateName = (plan) => `${plan?.templateName}`;

const profileSearch = ({
  selectedProfile,
  dayProfiles = [],
  datedProfiles = [],
  templates = [],
}) => {
  if (
    !selectedProfile ||
    !selectedProfile.type ||
    selectedProfile.value === undefined
  )
    return;

  switch (selectedProfile.type) {
    case DAY:
      return dayProfiles.find(
        (profile) =>
          parseInt(profile.day, 10) === parseInt(selectedProfile.value, 10)
      );
    case DATED:
      return datedProfiles.find(
        (profile) => profile.templateId === selectedProfile.value
      );
    case TEMPLATE:
      return templates.find(
        (profile) => profile.templateId === selectedProfile.value
      );
    default:
      return;
  }
};

export const findProfile = memoize(profileSearch);

export const formatProfileName = ({ type = DAY, profile }) => {
  if (!profile) return;

  switch (type) {
    case DAY:
      return DAYS[profile.day];
    case DATED:
      return formatDatedPlanName(profile);
    case TEMPLATE:
      return formatTemplateName(profile);
    default:
      return;
  }
};
